import WidgetService from '../../../services/WidgetService';

export default {
    namespaced: true,
    state: () => ({
        widgetList: [],
        widgetLists: [],
        allWidgetList: null,
        allWidgetListLoading: false,
    }),
    mutations: {
        setWidgetLists: (state, lists) => {
            state.allWidgetList = lists;
        },
        setWidgetList: (state, list) => {
            state.widgetList = list;
        },
        pushWidgetList: (state, list) => {
            state.widgetLists = {...list};
        }
    },
    actions: {
        widget: ({commit}, params) => {
            return new Promise((resolve, reject) => {
                WidgetService.widget(params).then(res => {
                    commit('pushWidgetList', res.data)
                    resolve(res)
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        systemTree: ({commit}, params) => {
            return new Promise((resolve, reject) => {
                WidgetService.systemTree(params).then(res => {
                    resolve(res)
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        addWidgetList: (store, widgetList) => {
            return new Promise((resolve, reject) => {
                WidgetService.addWidgetList(widgetList).then(res => {
                    console.log(res);
                    store
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        editWidgetList: (store, widgetList) => {
            return new Promise((resolve, reject) => {
                WidgetService.editWidgetList(widgetList).then(res => {
                    store
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        deleteWidgetList: ({dispatch}, widgetListSysName) => {
            return new Promise((resolve, reject) => {
                WidgetService.deleteWidgetList(widgetListSysName).then(res => {
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                })
            })
        },
        allWidgetList: ({commit, state}, params) => {
            return new Promise((resolve, reject) => {
                state.allWidgetListLoading = true;
                WidgetService.allWidgetList(params).then(res => {
                    commit('setWidgetLists', res.data);
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                }).finally(() => {
                    state.allWidgetListLoading = false;
                })
            })
        },
        getWidgetList: ({commit}, params) => {
            return new Promise((resolve, reject) => {
                WidgetService.getWidgetList(params).then(res => {
                    commit('setWidgetList', res.data)
                    resolve(res);
                }).catch((err) => {
                    reject(err);
                })
            })
        }
    }
}